import { ref } from 'vue';
import { defineStore } from 'pinia';

// TODO: replace with useModals store
export const useTranslateJob = defineStore('documentTranslateJob', () => {
  const modalVisible = ref(false);

  const setModalVisible = (visible) => {
    modalVisible.value = visible;
  };

  return {
    modalVisible,
    setModalVisible,
  };
});
